import axios from 'axios';
import { METHOD } from './constants';

const { get } = METHOD;

const mainRequestConfig = {
    baseURL: process.env.REACT_APP_API_URL
    //   headers: {'Content-Type': 'application/x-www-form-urlencoded'}
}



const mainAxiosInstance = axios.create(mainRequestConfig);

const mainRequest = (url, values, method) => {
    const data = values;
    let params;
    if (method === get) {
        params = values;
    }
    return mainAxiosInstance({ url, data, params, method });
}

export {
    mainRequest
}